module.exports = __webpack_public_path__ + "static/media/HeartFilled.33704495.svg";